<template>
    <Table class="UserManagementUsersTable">
        <template #head>
            <HeadCell>User</HeadCell>
            <HeadCell>Role</HeadCell>
            <HeadCell class="UserManagementUsersTable__actionsHead" />
        </template>

        <UsersTableRow
            v-for="user in users"
            :key="user.id"
            :user="user"
            :user-label="user.email === currentUserEmail ? 'you' : null"
            :dynamic-creation-enabled="dynamicCreationEnabled"
            :sso-connection-name="ssoConnectionName"
            @edit="$emit('edit', user)"
            @delete="$emit('delete', user)"
            @resend-invite="$emit('resendInvite', user)"
            @change-role="$emit('change-role', user, $event)"
        />

        <template v-if="loadingMore" #status>
            <LineLoader />
            <span>Loading users...</span>
        </template>
        <template v-else-if="!canLoadMore" #status>
            No more users found.
        </template>
    </Table>
</template>

<style lang="scss">
.UserManagementUsersTable {
    & &__actionsHead {
        max-width: 30px;
        text-align: center;
    }

    & &__actionsHead .TableHeader__inner {
        justify-content: center;
    }
}
</style>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { Avatar } from '@evidentid/dashboard-commons/components/Avatar';
    import { Badge } from '@evidentid/dashboard-commons/components/Badge';
    import { LineLoader } from '@evidentid/dashboard-commons/components/LineLoader';
    import { Table, Cell, Row, HeadCell } from '@evidentid/dashboard-commons/components/Table';
    import type { User } from '@evidentid/tprm-portal-lib/models/user-management/User.model';

    import UsersTableRow from './UsersTableRow.vue';

    @Component({
        emits: [ 'change-role', 'delete', 'edit', 'resendInvite' ],
        components: {
            UsersTableRow,
            LineLoader,
            Badge,
            Avatar,
            Table,
            Cell,
            Row,
            HeadCell,
        },
    })
    export default class UsersTable extends Vue {
        @Prop({ type: Array, default: [] })
        private users!: User[];

        @Prop({ type: Boolean, default: true })
        private canLoadMore!: boolean;

        @Prop({ type: Boolean, default: false })
        private loadingMore!: boolean;

        @Prop({ type: String, default: null })
        private currentUserEmail!: string | null;

        @Prop({ type: Boolean, default: false })
        private dynamicCreationEnabled!: boolean;

        @Prop({ type: String, default: null })
        private ssoConnectionName!: string | null;
    }
</script>
